"use client";

export function WayakSignal({ className = "" }: { className?: string }) {
  return <span className={`wk-brand-signal ${className}`} aria-hidden="true" />;
}

export function WayakSignalStyles() {
  return (
    <style>{`
      .wk-brand-signal { position: absolute; display: block; aspect-ratio: 1237 / 1328; pointer-events: none; contain: paint; isolation: isolate; }
      .wk-brand-signal::before,.wk-brand-signal::after { content: ""; position: absolute; inset: 0; display: block; -webkit-mask: url("/landing-v3/emblem_white.png") center / contain no-repeat; mask: url("/landing-v3/emblem_white.png") center / contain no-repeat; }
      .wk-brand-signal::before { z-index: 0; background: rgba(255,255,255,.115); transform: scale(1.008); }
      .wk-brand-signal::after { z-index: 1; background: var(--wk-signal-cutout,#09090b); transform: scale(.992); }
    `}</style>
  );
}
